var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconSolvencyDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6743 16.7015C17.7382 16.7654 17.7888 16.8412 17.8234 16.9246C17.858 17.0081 17.8758 17.0975 17.8758 17.1879C17.8758 17.2782 17.858 17.3677 17.8234 17.4511C17.7888 17.5346 17.7382 17.6104 17.6743 17.6743C17.6104 17.7382 17.5346 17.7888 17.4511 17.8234C17.3677 17.858 17.2782 17.8758 17.1879 17.8758C17.0975 17.8758 17.0081 17.858 16.9246 17.8234C16.8412 17.7888 16.7654 17.7382 16.7015 17.6743L11.0004 11.9723L5.29929 17.6743C5.17029 17.8033 4.99532 17.8758 4.81288 17.8758C4.63044 17.8758 4.45548 17.8033 4.32648 17.6743C4.19747 17.5453 4.125 17.3703 4.125 17.1879C4.125 17.0054 4.19747 16.8305 4.32648 16.7015L10.0284 11.0004L4.32648 5.29929C4.19747 5.17029 4.125 4.99532 4.125 4.81288C4.125 4.63044 4.19747 4.45548 4.32648 4.32648C4.45548 4.19747 4.63044 4.125 4.81288 4.125C4.99532 4.125 5.17029 4.19747 5.29929 4.32648L11.0004 10.0284L16.7015 4.32648C16.8305 4.19747 17.0054 4.125 17.1879 4.125C17.3703 4.125 17.5453 4.19747 17.6743 4.32648C17.8033 4.45548 17.8758 4.63044 17.8758 4.81288C17.8758 4.99532 17.8033 5.17029 17.6743 5.29929L11.9723 11.0004L17.6743 16.7015Z",
    fill: "#DAD9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconSolvencyDark);
export default __webpack_public_path__ + "static/media/close-icon-solvency-dark.de3606aadfa9bc524eb0ec83a9c8fd0f.svg";
export { ForwardRef as ReactComponent };